export class Terms {

    constructor() {
        this.id = null
        this.term_type = null
        this.title = null
        this.content = null
        this.created_at = null
        this.updated_at = null
    }
}

/*
"id": 2,
"term_type": "privacy",
"title": "개인정보 취급방침",
*/

/*
"id": 1,
"term_type": "use",
"title": "이용약관",
}*/
